import { IPayin, PayinStatus } from '@/store/models/payin.model';

export const payinsMethodIds: number[] = [20, 27];

export function useKYCIndications(payins: IPayin[] | undefined): {
  settledPayins: IPayin[];
  pendingPayins: IPayin[];
} {
  if (!payins) {
    return {
      settledPayins: [],
      pendingPayins: [],
    };
  }

  const settledPayins = payins?.filter((payin) => {
    return payin.payinStatus === PayinStatus.VALIDATED && payinsMethodIds.includes(Number(payin.paymentMethodId));
  });

  const pendingPayins = payins?.filter((payin) => {
    return payin.payinStatus === PayinStatus.PENDING && payinsMethodIds.includes(Number(payin.paymentMethodId));
  });

  return {
    settledPayins,
    pendingPayins,
  };
}
